import { render } from "./PlanDetail.vue?vue&type=template&id=56b8bae8&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"

import "./PlanDetail.vue?vue&type=style&index=0&id=56b8bae8&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b8bae8"]])

export default __exports__